import { useEffect, useState } from 'react';
import './style.css';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import CardDetalheContrato from '../../../../components/card_detalhe_contrato';
import CancelContractModal from '../../../../components/CancelContractModal';
import ToastNotification from '../../../../components/toast_notification';
import TabelaDinamica from '../../../../components/tabela_dinamica';
import { useApi } from '../../../../hooks/ApiGateway';
import { API_CONFIG } from '../../../../config/api';

type DataType = {
  widgets: any[];
};

const DetalhesContrato = () => {
  const { numero_documento, id } = useParams();
  const id_remessa = id;
  const id_usuario = localStorage.getItem("id_usuario");

  const [detalhesContratoData, setDetalhesContratoData] = useState<any>(null);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupStatus, setPopupStatus] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const handleSubmitCancel = async (contratos: { numero_documento: string; razao_cancelamento: string }[]) => {
    if (!numero_documento) return;
    const body = {
      id_usuario: id_usuario,
      contratos: contratos
    };

    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/acoes-remessa/cancelar?id_remessa=${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || 'Erro ao cancelar os contratos');
      }

      const data = await response.json();
      setPopupMessage(data.message);
      setPopupStatus(Number(data.status));
      setShowModalCancel(false);
    } catch (error) {
      console.error('Erro na requisição:', error);
      setPopupMessage(error instanceof Error ? error.message : 'Ocorreu um erro ao processar o cancelamento.');
      setPopupStatus(500);
    } finally {
      setShowPopup(true);
    }
  };

  const handleCancel = () => {
    setShowModalCancel(true);
  };

  const { makeGetRequest } = useApi<DataType>();

  const fetchData = async () => {
    const result = await makeGetRequest(`${API_CONFIG.BASE_URL}/cessao/detalhe/base-aceita/detalhes-contrato?id_remessa=${id_remessa}&id_contrato=${numero_documento}`);

    const cleanedBody = result.body.body.replace(/:\s*NaN/g, ': null');
    const responseData = JSON.parse(cleanedBody);

    if (responseData?.message === 'Erro ao processar contratos elegíveis') {
      setDetalhesContratoData({ 'widgets': [{ 'resumo': null, 'config': null, 'data': null}] });
      navigate('/page-not-found')
    } else {
      setDetalhesContratoData(responseData);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ErrorBoundary>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link p-0 me-2"
            onClick={() => window.history.back()}
            style={{ textDecoration: 'none', fontSize: '1.2rem' }}
          >
            <FontAwesomeIcon icon={faChevronLeft} className="me-1" color="black" />
          </button>
          <h1 className="page-heading mb-0">DETALHE DO ATIVO</h1>
        </div>

        <button
          className="btn btn-sm btn-acao text-white"
          onClick={handleCancel}
        >
          <FontAwesomeIcon icon={faTimes} className="me-1" />
          Cancelar
        </button>
      </div>
      
      {isLoading && (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
      {detalhesContratoData && detalhesContratoData.widgets && detalhesContratoData.widgets[0] && (
        <>
          <CardDetalheContrato data={detalhesContratoData.widgets[0].resumo} />
          <div className="mt-3">
            <TabelaDinamica
              data={{
                columns: detalhesContratoData.widgets[0].config?.columns || [],
                rows: detalhesContratoData.widgets[0].data || []
              }}
              config={detalhesContratoData.widgets[0].config || {}}
              title="Parcelas"
              subtitle=""
            />
          </div>
        </>
      )}

      <CancelContractModal
        show={showModalCancel}
        onHide={() => setShowModalCancel(false)}
        onSubmit={handleSubmitCancel}
        idDocumento={numero_documento || ''}
      />

      {showPopup && (
        <ToastNotification
          status={popupStatus}
          message={popupMessage}
          onClose={() => setShowPopup(false)}
        />
      )}
    </ErrorBoundary>
  );
};

export default DetalhesContrato;